import { DataResponse } from './response';
import { downloadFilePost, get, post } from 'utils/api';

export type RoutingModel = {
  stepCode: string;
  stepName: string;
};
export type RoutingResponse = {
  data: Array<RoutingModel>;
  message: string;
  isSuccess: boolean;
};

export type DataInputRouting = {
  stepCode?: string;
  stepName?: string;
  equipmentList?: string[];
  description?: string;
  orderIndex?: number;
  isCM?: boolean;
  isVS?: boolean;
  isIN?: boolean;
  isRequired: string;
  isPrepareEquipment?: boolean;

  // Field of detail screen
  stepId?: string;
  actived?: boolean;
  equipmentListStr?: string[];
  equipmentProduction?: number;
  unit?: string | null;
  stt?: string;
  createBy?: string;
  createTime?: string;
  // Work center Internal ID
  workCenterInternalID?: string
  workCenterName?: string
};

export type DetailRoutingResponse = {
  data: DataInputRouting;
  message: string;
  isSuccess: boolean;
};
export interface IRoutingServices {
  //lay danh sach Cong doan
  getListRouting(keyword?: string): Promise<RoutingResponse>;
  // Create routing
  createRouting(data: DataInputRouting): Promise<DataResponse<boolean>>;
  // Detail routing
  getDetailRouting(stepId: string): Promise<DetailRoutingResponse>;
  // Update detail routing
  updateDetailRouting(data: DataInputRouting): Promise<DataResponse<boolean>>;
  // Search routing
  searchRouting(data: object): Promise<DataResponse<Array<DataInputRouting>>>;
  // Export routing
  exportRouting(data: object): Promise<void>;
}

export function createRoutingServices(): IRoutingServices {
  return {
    getListRouting: async (keyword?: string): Promise<RoutingResponse> => {
      return (await get(`MasterData/Common/GetDropDownRoutingList?${keyword ? `KeyWord=${keyword}` : ''}`)).data;
    },
    // Create routing
    createRouting: async (data: DataInputRouting): Promise<DataResponse<boolean>> => {
      return (await post(`MasterData/Routing/create-routing`, data)).data;
    },
    // Detail routing
    getDetailRouting: async (stepId: string): Promise<DetailRoutingResponse> => {
      return (await get(`MasterData/Routing/get-detail-routing${stepId && `?StepId=${stepId}`}`)).data;
    },
    // Update detail routing
    updateDetailRouting: async (data: DataInputRouting): Promise<DataResponse<boolean>> => {
      return (await post(`MasterData/Routing/edit-routing`, data)).data;
    },
    // Search routing
    searchRouting: async (data: object): Promise<DataResponse<DataInputRouting[]>> => {
      return (await post(`MasterData/Routing/search-routing`, data)).data;
    },
    // Export routing
    exportRouting: async (data: object) => {
      return await downloadFilePost(`MasterData/Routing/export-routing`, data);
    },
  };
}
